import { Injectable } from '@angular/core';

import { AuthGuard } from '@platform/auth/auth.guard';
import { CompositeGuard } from '@platform/routing/composite.guard';

import { UserProfileGuard } from './user-profile.guard';

@Injectable({
  providedIn: 'root',
})
export class UserProfileCompositeGuard extends CompositeGuard {
  constructor(authGuard: AuthGuard, createUserGuard: UserProfileGuard) {
    super([authGuard, createUserGuard]);
  }
}
